import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BREVO_FORM_ACTION = process.env.REACT_APP_BREVO_FORM_URL;

const Enquire = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set Brevo global config
    window.REQUIRED_CODE_ERROR_MESSAGE = 'Please choose a country code';
    window.LOCALE = 'en';
    window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE =
      'The information provided is invalid. Please review the field format and try again.';
    window.REQUIRED_ERROR_MESSAGE = 'This field cannot be left blank. ';
    window.GENERIC_INVALID_MESSAGE =
      'The information provided is invalid. Please review the field format and try again.';
    window.INVALID_DATE = 'Please enter a valid date';
    window.translation = {
      common: {
        selectedList: '{quantity} list selected',
        selectedLists: '{quantity} lists selected',
        selectedOption: '{quantity} selected',
        selectedOptions: '{quantity} selected',
      },
    };
    window.AUTOHIDE = false;

    // Load Brevo validation JS
    const script = document.createElement('script');
    script.src = 'https://sibforms.com/forms/end-form/build/main.js';
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div data-testid="enquire-page" className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-black">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-5 flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            data-testid="enquire-back-btn"
            className="text-white/60 hover:text-white text-sm font-medium flex items-center gap-2 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
          <span className="text-white font-serif text-xl font-semibold tracking-wide">Wedding Video Essex</span>
          <div className="w-16" />
        </div>
      </div>

      {/* Form Section */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20">
        <div className="max-w-xl mx-auto">
          <div className="text-center mb-8">
            <p className="text-gold text-xs font-semibold uppercase tracking-widest mb-3">Zero pressure. Zero obligation.</p>
            <h1 className="font-serif text-3xl sm:text-4xl text-gray-900 mb-3">Tell us about your day</h1>
            <p className="text-gray-500 text-sm">Fill in a few details and we'll get back to you within 24 hours. Usually much sooner.</p>
          </div>

          {/* Native Brevo Form */}
          <div className="sib-form" style={{ textAlign: 'center', backgroundColor: '#ffffff' }}>
            <div id="sib-form-container" className="sib-form-container">
              <div
                id="error-message"
                className="sib-form-message-panel"
                style={{
                  fontSize: '16px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif',
                  color: '#661d1d', backgroundColor: '#ffeded', borderRadius: '3px',
                  borderColor: '#ff4949', maxWidth: '540px',
                }}
              >
                <div className="sib-form-message-panel__text sib-form-message-panel__text--center">
                  <svg viewBox="0 0 512 512" className="sib-icon sib-notification__icon">
                    <path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z" />
                  </svg>
                  <span className="sib-form-message-panel__inner-text">
                    Your subscription could not be saved. Please try again.
                  </span>
                </div>
              </div>
              <div></div>
              <div
                id="success-message"
                className="sib-form-message-panel"
                style={{
                  fontSize: '16px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif',
                  color: '#085229', backgroundColor: '#e7faf0', borderRadius: '3px',
                  borderColor: '#13ce66', maxWidth: '540px',
                }}
              >
                <div className="sib-form-message-panel__text sib-form-message-panel__text--center">
                  <svg viewBox="0 0 512 512" className="sib-icon sib-notification__icon">
                    <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z" />
                  </svg>
                  <span className="sib-form-message-panel__inner-text">
                    Thank you for submitting your quote request. Please check your inbox for more details.
                  </span>
                </div>
              </div>
              <div></div>

              <div
                id="sib-container"
                className="sib-container--large sib-container--vertical"
                style={{
                  textAlign: 'center', backgroundColor: 'rgba(255,255,255,1)',
                  maxWidth: '540px', borderRadius: '3px', borderWidth: '1px',
                  borderColor: '#C0CCD9', borderStyle: 'solid', direction: 'ltr',
                }}
              >
                <form
                  id="sib-form"
                  method="POST"
                  action={BREVO_FORM_ACTION}
                  data-type="subscription"
                >
                  {/* Title */}
                  <div style={{ padding: '8px 0' }}>
                    <div className="sib-form-block" style={{
                      fontSize: '18px', textAlign: 'center', fontWeight: 700,
                      fontFamily: '"Lucida Grande", sans-serif', color: '#3C4858',
                      backgroundColor: 'transparent',
                    }}>
                      <p>Please Request Your Quote Here</p>
                    </div>
                  </div>

                  {/* First Name */}
                  <div style={{ padding: '8px 0' }}>
                    <div className="sib-input sib-form-block">
                      <div className="form__entry entry_block">
                        <div className="form__label-row">
                          <label className="entry__label" style={{ fontWeight: 700, textAlign: 'left', fontSize: '12px', fontFamily: '"Lucida Grande", sans-serif', color: '#3c4858' }} htmlFor="FIRSTNAME" data-required="*">Your First Name</label>
                          <div className="entry__field">
                            <input className="input" maxLength="200" type="text" id="FIRSTNAME" name="FIRSTNAME" autoComplete="off" placeholder=" " data-required="true" required />
                          </div>
                        </div>
                        <label className="entry__error entry__error--primary" style={{ fontSize: '16px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#661d1d', backgroundColor: '#ffeded', borderRadius: '3px', borderColor: '#ff4949' }}></label>
                      </div>
                    </div>
                  </div>

                  {/* Last Name */}
                  <div style={{ padding: '8px 0' }}>
                    <div className="sib-input sib-form-block">
                      <div className="form__entry entry_block">
                        <div className="form__label-row">
                          <label className="entry__label" style={{ fontWeight: 700, textAlign: 'left', fontSize: '12px', fontFamily: '"Lucida Grande", sans-serif', color: '#3c4858' }} htmlFor="LASTNAME" data-required="*">Your Last Name</label>
                          <div className="entry__field">
                            <input className="input" maxLength="200" type="text" id="LASTNAME" name="LASTNAME" autoComplete="off" data-required="true" required />
                          </div>
                        </div>
                        <label className="entry__error entry__error--primary" style={{ fontSize: '16px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#661d1d', backgroundColor: '#ffeded', borderRadius: '3px', borderColor: '#ff4949' }}></label>
                      </div>
                    </div>
                  </div>

                  {/* Partner's First Name */}
                  <div style={{ padding: '8px 0' }}>
                    <div className="sib-input sib-form-block">
                      <div className="form__entry entry_block">
                        <div className="form__label-row">
                          <label className="entry__label" style={{ fontWeight: 700, textAlign: 'left', fontSize: '12px', fontFamily: '"Lucida Grande", sans-serif', color: '#3c4858' }} htmlFor="PARTNER_FIRST_NAME" data-required="*">Your Partner's First Name</label>
                          <div className="entry__field">
                            <input className="input" maxLength="200" type="text" id="PARTNER_FIRST_NAME" name="PARTNER_FIRST_NAME" autoComplete="off" data-required="true" required />
                          </div>
                        </div>
                        <label className="entry__error entry__error--primary" style={{ fontSize: '16px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#661d1d', backgroundColor: '#ffeded', borderRadius: '3px', borderColor: '#ff4949' }}></label>
                      </div>
                    </div>
                  </div>

                  {/* Email */}
                  <div style={{ padding: '8px 0' }}>
                    <div className="sib-input sib-form-block">
                      <div className="form__entry entry_block">
                        <div className="form__label-row">
                          <label className="entry__label" style={{ fontWeight: 700, textAlign: 'left', fontSize: '12px', fontFamily: '"Lucida Grande", sans-serif', color: '#3c4858' }} htmlFor="EMAIL" data-required="*">Your Email Address</label>
                          <div className="entry__field">
                            <input className="input" type="text" id="EMAIL" name="EMAIL" autoComplete="off" placeholder="" data-required="true" required />
                          </div>
                        </div>
                        <label className="entry__error entry__error--primary" style={{ fontSize: '16px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#661d1d', backgroundColor: '#ffeded', borderRadius: '3px', borderColor: '#ff4949' }}></label>
                      </div>
                    </div>
                  </div>

                  {/* Mobile No */}
                  <div style={{ padding: '8px 0' }}>
                    <div className="sib-sms-field sib-form-block">
                      <div className="form__entry entry_block">
                        <div className="form__label-row">
                          <label className="entry__label" style={{ fontWeight: 700, textAlign: 'left', fontSize: '12px', fontFamily: '"Lucida Grande", sans-serif', color: '#3c4858' }} htmlFor="SMS" data-required="*">Mobile No.</label>
                          <div className="sib-sms-input-wrapper" style={{ direction: 'ltr' }}>
                            <div className="sib-sms-input" data-placeholder="" data-required="1" data-country-code="GB" data-whatsapp-country-code="GB" data-value="" data-whatsappvalue="" data-attributename="SMS">
                              <div className="entry__field">
                                <select className="input" name="SMS__COUNTRY_CODE" data-required="true" defaultValue="+44">
                                  <option value="+44">+44 GB</option>
                                  <option value="+1">+1 US</option>
                                  <option value="+353">+353 IE</option>
                                  <option value="+33">+33 FR</option>
                                  <option value="+49">+49 DE</option>
                                  <option value="+34">+34 ES</option>
                                  <option value="+39">+39 IT</option>
                                  <option value="+351">+351 PT</option>
                                  <option value="+31">+31 NL</option>
                                  <option value="+32">+32 BE</option>
                                  <option value="+41">+41 CH</option>
                                  <option value="+43">+43 AT</option>
                                  <option value="+45">+45 DK</option>
                                  <option value="+46">+46 SE</option>
                                  <option value="+47">+47 NO</option>
                                  <option value="+48">+48 PL</option>
                                  <option value="+61">+61 AU</option>
                                  <option value="+64">+64 NZ</option>
                                  <option value="+91">+91 IN</option>
                                  <option value="+86">+86 CN</option>
                                  <option value="+81">+81 JP</option>
                                  <option value="+82">+82 KR</option>
                                  <option value="+55">+55 BR</option>
                                  <option value="+52">+52 MX</option>
                                  <option value="+27">+27 ZA</option>
                                  <option value="+971">+971 AE</option>
                                  <option value="+966">+966 SA</option>
                                  <option value="+65">+65 SG</option>
                                  <option value="+852">+852 HK</option>
                                  <option value="+90">+90 TR</option>
                                  <option value="+7">+7 RU</option>
                                  <option value="+380">+380 UA</option>
                                  <option value="+20">+20 EG</option>
                                  <option value="+234">+234 NG</option>
                                  <option value="+254">+254 KE</option>
                                  <option value="+62">+62 ID</option>
                                  <option value="+66">+66 TH</option>
                                  <option value="+84">+84 VN</option>
                                  <option value="+63">+63 PH</option>
                                  <option value="+60">+60 MY</option>
                                </select>
                              </div>
                              <div className="entry__field" style={{ width: '100%' }}>
                                <input type="tel" className="input" id="SMS" name="SMS" autoComplete="off" placeholder="SMS" data-required="true" required />
                              </div>
                            </div>
                            <div className="sib-sms-tooltip">
                              <div className="sib-sms-tooltip__box">
                                The SMS field must contain between 6 and 19 digits and include the country code without using +/0 (e.g. 1xxxxxxxxxx for the United States)
                              </div>
                              <span className="sib-sms-tooltip__icon">?</span>
                            </div>
                          </div>
                        </div>
                        <label className="entry__error entry__error--primary" style={{ fontSize: '16px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#661d1d', backgroundColor: '#ffeded', borderRadius: '3px', borderColor: '#ff4949' }}></label>
                        <label className="entry__error entry__error--secondary" style={{ fontSize: '16px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#661d1d', backgroundColor: '#ffeded', borderRadius: '3px', borderColor: '#ff4949' }}></label>
                      </div>
                    </div>
                  </div>

                  {/* Date of Wedding */}
                  <div style={{ padding: '8px 0' }}>
                    <div className="sib-input sib-form-block">
                      <div className="form__entry">
                        <div className="form__label-row">
                          <label className="entry__label" style={{ fontWeight: 700, textAlign: 'left', fontSize: '12px', fontFamily: '"Lucida Grande", sans-serif', color: '#3c4858' }} htmlFor="DATE_OF_WEDDING" data-required="*">Date of Wedding</label>
                          <div className="entry__field">
                            <input maxLength="200" type="text" data-type="date" className="input" pattern="^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\d{4}$" title="dd-mm-yyyy" data-format="dd-mm-yyyy" id="DATE_OF_WEDDING" name="DATE_OF_WEDDING" autoComplete="off" placeholder="" data-required="true" required />
                          </div>
                        </div>
                        <label className="entry__error entry__error--primary" style={{ fontSize: '16px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#661d1d', backgroundColor: '#ffeded', borderRadius: '3px', borderColor: '#ff4949' }}></label>
                        <label className="entry__specification" style={{ fontSize: '12px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#8390A4' }}>
                          dd-mm-yyyy
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Wedding Venue */}
                  <div style={{ padding: '8px 0' }}>
                    <div className="sib-input sib-form-block">
                      <div className="form__entry entry_block">
                        <div className="form__label-row">
                          <label className="entry__label" style={{ fontWeight: 700, textAlign: 'left', fontSize: '12px', fontFamily: '"Lucida Grande", sans-serif', color: '#3c4858' }} htmlFor="NAME_OF_VENUE" data-required="*">Wedding Venue</label>
                          <div className="entry__field">
                            <input className="input" maxLength="200" type="text" id="NAME_OF_VENUE" name="NAME_OF_VENUE" autoComplete="off" data-required="true" required />
                          </div>
                        </div>
                        <label className="entry__error entry__error--primary" style={{ fontSize: '16px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#661d1d', backgroundColor: '#ffeded', borderRadius: '3px', borderColor: '#ff4949' }}></label>
                      </div>
                    </div>
                  </div>

                  {/* Package Required */}
                  <div style={{ padding: '8px 0' }}>
                    <div className="sib-checkbox-group sib-form-block" data-required="true">
                      <div className="form__entry entry_mcq">
                        <div className="form__label-row">
                          <label className="entry__label" style={{ fontWeight: 700, textAlign: 'left', fontSize: '12px', fontFamily: '"Lucida Grande", sans-serif', color: '#3c4858' }} data-required="*">Package Required</label>
                          <div>
                            <div className="entry__choice">
                              <label className="checkbox__label">
                                <input type="checkbox" className="input_replaced" name="PACKAGE_TYPE[]" data-value="Videography Package" value="Videography Package" data-required="true" />
                                <span className="checkbox checkbox_tick_positive" style={{ marginLeft: '' }}></span>
                                <span style={{ fontSize: '14px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#3C4858', backgroundColor: 'transparent' }}>Videography Package</span>
                              </label>
                            </div>
                            <div className="entry__choice">
                              <label className="checkbox__label">
                                <input type="checkbox" className="input_replaced" name="PACKAGE_TYPE[]" data-value="Videography &amp; Photography Package" value="Videography &amp; Photography Package" data-required="true" />
                                <span className="checkbox checkbox_tick_positive" style={{ marginLeft: '' }}></span>
                                <span style={{ fontSize: '14px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#3C4858', backgroundColor: 'transparent' }}>Videography &amp; Photography Package</span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <label className="entry__error entry__error--primary" style={{ fontSize: '16px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#661d1d', backgroundColor: '#ffeded', borderRadius: '3px', borderColor: '#ff4949' }}></label>
                      </div>
                    </div>
                  </div>

                  {/* Opt In */}
                  <div style={{ padding: '8px 0' }}>
                    <div className="sib-optin sib-form-block" data-required="true">
                      <div className="form__entry entry_mcq">
                        <div className="form__label-row">
                          <div className="entry__choice">
                            <label>
                              <input type="checkbox" className="input_replaced" value="1" id="OPT_IN" name="OPT_IN" required />
                              <span className="checkbox checkbox_tick_positive" style={{ marginLeft: '' }}></span>
                              <span style={{ fontSize: '12px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#3C4858', backgroundColor: 'transparent' }}>
                                <p>I am happy to receive information from Wedding Video Essex and accept the data privacy statement. You can unsubscribe at any time.</p>
                                <span data-required="*" style={{ display: 'inline' }} className="entry__label entry__label_optin"></span>
                              </span>
                            </label>
                          </div>
                        </div>
                        <label className="entry__error entry__error--primary" style={{ fontSize: '16px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#661d1d', backgroundColor: '#ffeded', borderRadius: '3px', borderColor: '#ff4949' }}></label>
                      </div>
                    </div>
                  </div>

                  {/* Hidden field */}
                  <div style={{ padding: '8px 0' }}>
                    <div className="sib-input sib-form-block">
                      <div className="form__entry entry_block">
                        <div className="form__label-row">
                          <div className="entry__field">
                            <input className="input" maxLength="200" type="text" id="WEBSITE_LEAD" name="WEBSITE_LEAD" autoComplete="off" />
                          </div>
                        </div>
                        <label className="entry__error entry__error--primary" style={{ fontSize: '16px', textAlign: 'left', fontFamily: 'Helvetica, sans-serif', color: '#661d1d', backgroundColor: '#ffeded', borderRadius: '3px', borderColor: '#ff4949' }}></label>
                      </div>
                    </div>
                  </div>

                  {/* Submit */}
                  <div style={{ padding: '8px 0' }}>
                    <div className="sib-form-block" style={{ textAlign: 'left' }}>
                      <button
                        className="sib-form-block__button sib-form-block__button-with-loader"
                        style={{
                          fontSize: '16px', textAlign: 'left', fontWeight: 700,
                          fontFamily: 'Helvetica, sans-serif', color: '#FFFFFF',
                          backgroundColor: '#868789', borderRadius: '3px', borderWidth: '0px',
                        }}
                        form="sib-form"
                        type="submit"
                        data-testid="enquire-submit-btn"
                      >
                        <svg className="icon clickable__icon progress-indicator__icon sib-hide-loader-icon" viewBox="0 0 512 512">
                          <path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z" />
                        </svg>
                        Submit
                      </button>
                    </div>
                  </div>

                  <input type="text" name="email_address_check" defaultValue="" className="input--hidden" />
                  <input type="hidden" name="locale" value="en" />
                </form>
              </div>
            </div>
          </div>

          <p className="text-gray-400 text-xs text-center mt-4">
            We never share your information. See our <a href="/privacy" className="underline hover:text-gray-600 transition-colors">privacy policy</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Enquire;
